<template>
  <a-modal :title="modal.title" v-model="modal.visible" @cancel="handleCancel" :width="700">
    <a-table
      class="queryView-table"
      :rowKey="(record, index)=>{return index}"
      :columns="tableColumns"
      :dataSource="dataSource"
      :rowSelection="getRowSelection('radio')"
      size="middle"
      :scroll="{ x: 600, y: 500 }"
      :pagination="false"
    ></a-table>
    <template slot="footer">
      <a-button @click="handleOk" type="primary">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <div>{index + 1}</div>
        },
      },
      {
        title: '模版名',
        width: '30%',
        align: 'center',
        dataIndex: 'materialTemplateName',
      },
      {
        title: '添加时间',
        width: '30%',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '操作',
        width: '30%',
        align: 'center',
        customRender: (row, index) => {
          return (
            <div class="flex gap-5 justify-center">
              <a
                onClick={() => {
                  this.removeRow(row)
                }}
              >
                <app-icon type="icon-shanchu"></app-icon>
              </a>
            </div>
          )
        },
      },
    ]
    return {
      tableColumns: tableColumns,
      dataSource: [],
      rowKey: 'materialTemplateId',
      productType: '',
      selectedRowKeys: [],
      selectedRows: [],
      modal: {
        visible: false,
        title: '选择模板',
        data: {},
      },
    }
  },
  methods: {
    getRowSelection(type) {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        columnTitle: '选择',
        columnWidth: 80,
        type: type,
      }
    },
    async start({ productType = '' } = {}) {
      this.reset$t()
      this.productType = productType
      this.modal.visible = true
      this.doQuery(productType)
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          } else if (state === 'cancel') {
            resolve()
          } else {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      if (!this.selectedRows.length) {
        return this.$message.error('请选择')
      }
      this.$emit('end', 'ok', this.selectedRows)
    },
    handleCancel() {
      // this.$emit('end', 'cancel')
      this.modal.visible = false
    },
    async doQuery() {
      const { productType } = this
      const res = await this.$axios.post('/visa/admin/productMaterialTemplate/queryTemplateByProductType', {
        data: { productType },
      })
      this.dataSource = res.data
    },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.post('/visa/admin/productMaterialTemplate/deleteByTemplateId', {
        data: {
          materialTemplateId: row.materialTemplateId,
        },
      })
      this.$message.success('操作成功!')
      this.doQuery()
    },
  },
}
</script>

<style lang="less" scoped>
.modal-h {
  max-height: 800px;
  overflow: auto;
}
</style>
